import { StarsButton, Translation } from '@ps/web-shared-components';
import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';

import ExchangeIcon from '@swf/components/StarsRewards/assets/exchange.svg';
import PanelItem from '@swf/components/StarsRewards/components/PanelItem/PanelItem';
import type { Dispatch, RootState } from '@swf/core/store';

import {
  TXTCLI_Cancel,
  TXTCLI_Click_for_more_information,
  TXTCLI_Do_you_want_to_exchange_your_c_ELL,
  TXTCLI_Exchange
} from './ExchangePanel.messages.json';
import styles from './ExchangePanel.scss';

type StateProps = ReturnType<typeof mapState>;
type DispatchProps = ReturnType<typeof mapDispatch>;

interface OwnProps {
  panelId: number;
  onOpenChestClick: () => void;
  cancelExchange: () => void;
  buttonClass: string;
}

export type Props = OwnProps & StateProps & DispatchProps;

class ExchangePanel extends React.PureComponent<Props> {
  exchange = () => {
    if (!this.props.loading) {
      this.props.exchange();
    }
  };

  render() {
    const { onOpenChestClick, buttonClass, cancelExchange, panelId } = this.props;

    return (
      <PanelItem panelId={panelId} panelClassName={styles.exchangePanel}>
        <div className={styles.exchangeForm}>
          <ExchangeIcon />
          <div className={styles.exchangeInfo}>
            <Translation {...TXTCLI_Do_you_want_to_exchange_your_c_ELL} />
          </div>
          <div className={styles.exchangeInfo}>
            <StarsButton
              variant="text"
              className={styles.moreInfo}
              onClick={onOpenChestClick}
              translation={TXTCLI_Click_for_more_information}
            />
          </div>

          <StarsButton
            variant="secondary"
            size="small"
            className={styles.exchange}
            onClick={cancelExchange}
            translation={TXTCLI_Cancel}
          />

          <StarsButton
            variant="legacy"
            size="tiny"
            className={buttonClass}
            onClick={this.exchange}
            loading={this.props.loading}
            translation={TXTCLI_Exchange}
          />
        </div>
      </PanelItem>
    );
  }
}

const mapState = (rootState: RootState) => ({
  loading: !!rootState.loading?.models.rewardsLegacy
});

const mapDispatch = ({ rewardsLegacy: { exchange } }: Dispatch) => ({
  exchange
});

export default compose(
  // @ts-ignore https://github.com/DefinitelyTyped/DefinitelyTyped/issues/31363
  connect<StateProps, DispatchProps, OwnProps>(mapState, mapDispatch)
)(ExchangePanel) as React.ComponentType<OwnProps>;
